<template>
  <div class="home-container">
    <div class="bg-white p-6 rounded-lg shadow-md">
      <h1 class="text-3xl font-bold text-gray-800 mb-6">首页</h1>
      
      <!-- 卡片区域 -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <el-card v-for="(card, index) in cards" :key="index" class="hover:shadow-lg transition-shadow">
          <template #header>
            <div class="flex items-center justify-between">
              <span class="font-medium">{{ card.title }}</span>
              <el-button type="text" :icon="More" circle />
            </div>
          </template>
          <div class="text-gray-600">
            {{ card.content }}
          </div>
          <div class="mt-4 flex justify-end">
            <el-button type="primary" size="small">查看详情</el-button>
          </div>
        </el-card>
      </div>
      
      <!-- 表格区域 -->
      <div class="mb-8">
        <h2 class="text-xl font-semibold text-gray-700 mb-4">数据列表</h2>
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column prop="date" label="日期" width="180" />
          <el-table-column prop="name" label="姓名" width="180" />
          <el-table-column prop="address" label="地址" />
          <el-table-column label="操作" width="180">
            <template #default="scope">
              <el-button type="primary" size="small" :icon="Edit" circle @click="handleEdit(scope.row)" />
              <el-button type="danger" size="small" :icon="Delete" circle @click="handleDelete(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 表单区域 -->
      <div>
        <h2 class="text-xl font-semibold text-gray-700 mb-4">信息表单</h2>
        <el-form :model="form" label-width="120px">
          <el-form-item label="姓名">
            <el-input v-model="form.name" placeholder="请输入姓名" />
          </el-form-item>
          <el-form-item label="活动区域">
            <el-select v-model="form.region" placeholder="请选择活动区域" style="width: 100%">
              <el-option label="上海" value="shanghai" />
              <el-option label="北京" value="beijing" />
              <el-option label="广州" value="guangzhou" />
              <el-option label="深圳" value="shenzhen" />
            </el-select>
          </el-form-item>
          <el-form-item label="活动时间">
            <el-date-picker v-model="form.date" type="date" placeholder="选择日期" style="width: 100%" />
          </el-form-item>
          <el-form-item label="即时配送">
            <el-switch v-model="form.delivery" />
          </el-form-item>
          <el-form-item label="活动性质">
            <el-checkbox-group v-model="form.type">
              <el-checkbox label="线上活动" name="type" />
              <el-checkbox label="促销活动" name="type" />
              <el-checkbox label="线下活动" name="type" />
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="特殊资源">
            <el-radio-group v-model="form.resource">
              <el-radio label="线上品牌商赞助" />
              <el-radio label="线下场地免费" />
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动形式">
            <el-input v-model="form.desc" type="textarea" rows="3" placeholder="请输入活动形式" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
import { Edit, Delete, More } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'HomePage',
  setup() {
    // 卡片数据
    const cards = [
      {
        title: '用户统计',
        content: '当前系统共有 1,234 名用户，较上月增长 12%'
      },
      {
        title: '订单统计',
        content: '本月共处理订单 567 笔，交易额 ¥123,456'
      },
      {
        title: '活动概况',
        content: '近期有 3 个活动正在进行中，8 个活动计划中'
      }
    ]

    // 表格数据
    const tableData = [
      {
        date: '2025-05-15',
        name: '张三',
        address: '上海市浦东新区张江高科技园区'
      },
      {
        date: '2025-05-14',
        name: '李四',
        address: '北京市朝阳区国贸中心'
      },
      {
        date: '2025-05-13',
        name: '王五',
        address: '广州市天河区珠江新城'
      },
      {
        date: '2025-05-12',
        name: '赵六',
        address: '深圳市南山区科技园'
      }
    ]

    // 表单数据
    const form = reactive({
      name: '',
      region: '',
      date: '',
      delivery: false,
      type: [],
      resource: '',
      desc: ''
    })

    // 处理编辑
    const handleEdit = (row) => {
      ElMessage({
        message: `编辑: ${row.name}`,
        type: 'success'
      })
    }

    // 处理删除
    const handleDelete = (row) => {
      ElMessageBox.confirm(
        `确定要删除 ${row.name} 的记录吗？`,
        '警告',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          ElMessage({
            type: 'success',
            message: '删除成功',
          })
        })
        .catch(() => {
          ElMessage({
            type: 'info',
            message: '已取消删除',
          })
        })
    }

    // 提交表单
    const onSubmit = () => {
      ElMessage({
        message: '表单提交成功！',
        type: 'success'
      })
      console.log('表单数据:', form)
    }

    return {
      // 数据
      cards,
      tableData,
      form,
      // 方法
      handleEdit,
      handleDelete,
      onSubmit,
      // 图标
      Edit,
      Delete,
      More
    }
  }
}
</script>

<style scoped>
.home-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
</style>
